import {TweenMax, Power2} from 'gsap';
// @ts-ignore
import {Draggable} from 'gsap/Draggable';
import {mod} from "src/ts/tools";

export class Carousel {

  public draggable: Draggable;
  public element: HTMLElement;
  public $element: JQuery<HTMLElement>;

  constructor(element: HTMLElement) {

    this.element = element;
    this.$element = $(element);


    this.initDraggable();
    this.setDots();
    this.updateActiveDot();
    this.events();
    this.setSpacerWidth();

    if (this.$element.find('.Triangle').length > 0) {
      console.log('Carousel Triangle détecté.');
      this.eventsTriangle();
    }
  }

  public initDraggable() {
    let _this = this;
    this.draggable = Draggable.create(_this.$element.find('.Carousel-wrapper'), {
      type: "scrollLeft",
      lockAxis: true,
      edgeResistance: 0.5,
      throwProps: true,
      dragClickables: true,
      snap: function (endValue: number) {
        return Math.round(-endValue / _this.getSlideWidth()) * _this.getSlideWidth();
      }
    });
    this.$element.find('.Carousel-wrapper > div').addClass('Carousel-draggable');
  }

  public events() {

    let _this = this;
    let windowWidth = $(window).width();

    this.$element.find('.btn-back').on('click', function (e: Event) {
      e.preventDefault();
      _this.prev();
    });
    this.$element.find('.btn-forward').on('click', function (e: Event) {
      e.preventDefault();
      _this.next();
    });

    this.$element.find('.Carousel-indicator').on('click', function () {
      _this.goTo($(this).index());
    });

    this.$element.find('.Carousel-wrapper').on('scroll', function () {
      _this.updateActiveDot();
    });

    $(window).resize(function () {
      if (windowWidth != $(window).width()) {
        _this.setSpacerWidth();
      }
      windowWidth = $(window).width();
    });
  }


  public getClickedTriangle(element: HTMLElement, e: MouseEvent) {
    let $element = $(element);
    let clickX = e.pageX - $element.box().offsetLeft;
    let clickY = e.pageY - $element.box().offsetTop;

    let width = $element.width();
    let height = $element.height();

    let clickXPercent = (clickX * 100 / width);
    let clickYPercent = (clickY * 100 / height);

    if (mod($element.index(), 2) !== 0) {
      clickYPercent = 100 - (clickY * 100 / height);
    }

    let limitXPercent = 100 - clickYPercent;

    if (clickXPercent < limitXPercent) {
      return $element.prev();
    }
    else {
      return $element;
    }
  }

  public eventsTriangle() {
    let _this = this;

    // @ts-ignore
    this.$element.find('.Triangle').on('click', function (e: MouseEvent) {
      e.preventDefault();
      let url = _this.getClickedTriangle(this, e).attr('href');
      if(typeof url === 'string'){
        window.location.href = url;
      }
    });
    // @ts-ignore
    this.$element.find('.Triangle').on('mousemove', function (e: MouseEvent) {
      TweenMax.to(_this.getClickedTriangle(this, e).find('svg'), 2, {scale: 1.1});
      TweenMax.to(_this.$element.find('.Triangle').not(_this.getClickedTriangle(this, e)).find('svg'), 1, {scale: 1});
    });
    // @ts-ignore
    this.$element.find('.Triangle').on('mouseout', function (e: MouseEvent) {
      TweenMax.to(_this.$element.find('.Triangle').find('svg'), 1, {scale: 1});
    });
  }

  public next() {
    this.goTo(this.getCurrent() + 1);
  }

  public prev() {
    this.goTo(this.getCurrent() - 1);
  }

  public goTo(pos: number) {
    // Animation
    TweenMax.to(this.$element.find('.Carousel-wrapper'), 1, {
      scrollLeft: pos * this.getSlideWidth(),
      ease: Power2.easeInOut
    });
  }


  public getCurrent() {
    return Math.round(this.$element.find('.Carousel-wrapper').scrollLeft() / this.getSlideWidth());
  }

  public getSliderItems() {
    return this.$element.find('.Carousel-item');
  }

  public getSlideWidth() {
    return this.getSliderItems().outerWidth(true);
  }

  public setDots() {
    let $carouselIndicatorList = this.$element.find('.Carousel-indicators-list');
    let $carouselIndicator = this.$element.find('.Carousel-indicator');
    $carouselIndicatorList.empty();

    this.getSliderItems().each(function () {
      $carouselIndicator.clone().appendTo($carouselIndicatorList);
    });

  }

  public updateActiveDot() {
    let $carouselIndicator = this.$element.find('.Carousel-indicator');
    $carouselIndicator.removeClass('active');
    $carouselIndicator.eq(this.getCurrent()).addClass('active');
  }

  public setSpacerWidth() {
    //Recalculer on resize
    let width = this.$element.find('.Carousel-wrapper').width() - this.getSlideWidth();
    this.$element.find('.Carousel-spacer').css('flex', '0 0 ' + width + 'px');
  }

}